import { htmlSafe } from '@ember/template';
import type { TOC } from '@ember/component/template-only';

export interface ItemCommentSignature {
  approverName?: string;
  approverComment?: string;
}

const ItemComment: TOC<ItemCommentSignature> = <template>
  {{#if @approverComment}}
    <div class="tio-feed__comment ml-14 rounded-md p-3">
      <div class="tio-flex-between gap-x-4">
        <div class="py-0.5 tio-text-caption leading-5">
          <span class="font-medium">{{@approverName}}</span>
          commented
        </div>
      </div>
      <p class="text-sm leading-6 tio-fg-muted">{{htmlSafe @approverComment}}</p>
    </div>
  {{/if}}
</template>;

export default ItemComment;

/**
 * Example usage:
 *
 *
 * Had originally intended to use inconjuction with ItemDetails.
    If wanting to use it solo, would want to move the comment up -bottom
 *     <Feed @feed={{this.timeline}}>
            <:comment as |item|>
              <ItemComment
                @approverComment={{item.approverComment}}
                @approverName={{item.approverName}}
              />
            </:comment>
          </Feed>

 */
